import { Field, Formik, Form, ErrorMessage } from "formik";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { IoClose } from "react-icons/io5";
import axios from "axios";
import { MODULE_URLS } from "../../constants/module-urls";
import { toast } from "react-toastify";

function KeywordAdd({ open, onClose }) {
  const initialValues = {
    keyword: "",
    response: "",
  };

  const onSubmit = async (values) => {
    const responseData = {
      keyword: values.keyword,
      response: values.response,
    };
    const response = await axios.post(
      `${MODULE_URLS.ADD_KEYWORD_TEXT}`,
      responseData
    );
    if (response.status === 200) {
      toast.success("Keyword Response Added Successfully!");
      onClose();
    }
  };

  const customModalStyles = {
    content: {
      width: "40%",
      height: "40vh",
      margin: "auto",
      padding: "10px 20px",
      zIndex: "",
    },
  };
  return (
    <Modal
      isOpen={open}
      shouldReturnFocusAfterClose={false}
      style={{
        ...customModalStyles,
        content: {
          ...customModalStyles.content,
          width: "80%",
        },
      }}
    >
      <div>
        <span
          style={{
            display: "flex",
            justifyContent: "space-between",
            borderBottom: "1px solid #000000",
          }}
        >
          <span className="modal-head-Text">Add Keywords Response</span>
          <IoClose
            color="#000000"
            size={"23px"}
            onClick={() => {
              onClose();
            }}
          />
        </span>
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          enableReinitialize={true}
        >
          {({ values }) => (
            <Form>
              <div
                style={{
                  paddingBottom: "5px",
                }}
              >
                <div className="create-financial-main-input-container">
                  <div
                    className="create-admission-inner-first-input-container"
                    style={{ width: "100%", marginTop: "10px" }}
                  >
                    <div className="label-text-active"> Enter Keyword</div>
                    <Field
                      name="keyword"
                      style={{
                        width: "100%",
                        padding: "5px 10px",
                        height: "50px",
                        marginTop: "5px",
                        borderRadius: "5px",
                      }}
                    />
                    <ErrorMessage
                      name="keyword"
                      component="div"
                      className="add-staff-error"
                    />
                  </div>

                  <div className="label-text-active"> Enter Response</div>
                  <Field
                    name="response"
                    style={{
                      width: "100%",
                      padding: "5px 10px",
                      height: "50px",
                      marginTop: "5px",
                      borderRadius: "5px",
                    }}
                  />
                  <ErrorMessage
                    name="respose"
                    component="div"
                    className="add-staff-error"
                  />
                </div>
              </div>
              <div
                style={{ position: "absolute", bottom: "20px", width: "auto" }}
              >
                <div className="d-flex align-items-center justify-content-end gap-3">
                  <button
                    className="list-add-bttn"
                    onClick={() => {
                      onClose();
                    }}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="list-add-bttn">
                    Submit
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Modal>
  );
}
export default KeywordAdd;
